import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { MultiSelect } from 'primereact/multiselect';

import { generateFullName } from 'utils/generateFullNameUtils';
import { getFileClients } from 'services/fileManager/fileManagerServices';
import InputErrorMessage from 'components/UI/InputErrorMessage/InputErrorMessage';

function ContactDropdown({ control, errors, caseId, isVisible = true }) {
  const [clientOptions, setClientOptions] = useState([]);
  const [clients, setClients] = useState([]);

  const fetchClients = async () => {
    const response = await getFileClients({ case_id: caseId });
    setClients(response?.data || []);
  };

  useEffect(() => {
    fetchClients();
  }, [caseId]);

  useEffect(() => {
    if (clients?.length > 0) {
      const sortedContacts = [...clients].sort((a, b) => {
        const nameA = a?.first_name || a?.title || '';
        const nameB = b?.first_name || b?.title || '';
        return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
      });

      const data = sortedContacts.map((element) => ({
        label: generateFullName(element),
        value: element?.client_cognito_username ? element?.client_cognito_username : element?.contact_id,
        email: element?.email,
        is_create_client_portal: element?.is_create_client_portal,
        contact_id: element?.contact_id ? element?.contact_id : '',
        file_name: element?.display_name ? element?.display_name : '',
      }));
      setClientOptions(data);
      return;
    }
    setClientOptions([]);
  }, [clients]);

  function checkOptionDisabled(index) {
    if (index.email === '' || !index.is_create_client_portal) {
      return true;
    }
    return false;
  }

  function ClientsOptionTemplate(e) {
    return (
      <div>
        {e.label} {!e.email ? '( Email address not found )' : !e.is_create_client_portal ? '( Lawft Access Disabled )' : ''}
      </div>
    );
  }

  if (!isVisible) {
    return null;
  }

  return (
    <div className="d-flex align-items-center flex-wrap">
      <div className="col-lg-4 col-12 p-medium">Share with Contact(s)</div>
      <div className="col-lg-8 col-12 select-tag-input">
        <Controller
          name="sharedContacts"
          control={control}
          defaultValue={[]}
          render={({ field }) => (
            <>
              <MultiSelect
                options={clientOptions}
                onChange={(e) => field.onChange(e.value)}
                placeholder="Select Contact(s)"
                className="input-shadow w-100 F-size14"
                filter
                id={field.name}
                value={field.value}
                optionLabel="label"
                optionValue="value"
                display="chip"
                emptyFilterMessage="No records found"
                optionDisabled={(index) => checkOptionDisabled(index)}
                itemTemplate={ClientsOptionTemplate}
              />
            </>
          )}
        />
        {errors?.sharedContacts && <InputErrorMessage>Required</InputErrorMessage>}
      </div>
    </div>
  );
}

export default ContactDropdown;
